module.exports = __webpack_public_path__ + "img/dl2.81329e01.png";